<template>
  <div>
<!--    <a role="button" class="btn btn-danger cbutton" @click="execSetting">封存本年度</a>-->

    <div class="row" style="width:800px;">
      <div class="col-12">
        <a role="button" class="btn btn-primary bbutton" @click="saveDataYear()">封存本屆資料 {{YearString}}  </a>
      </div>

    </div>
    <div class="row" style="width:800px;">
      <div class="col-3"  v-for="(item,index) in dataYears" :key="index">
        <a role="button" class="btn btn-primary bbutton" @click="loadDataYear(item)">{{item.Name}}</a>
      </div>

    </div>



    <div v-if="this.SelectYear !=='nothing'">
      <hr>
      <h1>年度Logo (建議圖片大小:265x265)</h1>
      <div v-if="datas.MenuTop">
        <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a> <br>
        <img :src="convertToRealUrl(datas.YearData.LogoUrl)" style="width:300px;height: 200px">
        <FileUploadButton :emmit-back-param="datas.YearData" v-on:uploadSuccess="uploadSuccess" ></FileUploadButton>
      </div>
      <hr>

      <h1>上方選單</h1>
      <ListCatalog :datas.sync="datas.MenuTop" bg-color="#2bac56"></ListCatalog>
      <hr>

      <h1>左側選單</h1>
      <ListCatalog :datas.sync="datas.MenuLeft" bg-color="#6cb2eb"></ListCatalog>

      <h1>首頁</h1>
      <ContentHome ref="contentHome" ></ContentHome>

    </div>


  </div>
</template>

<script>
import ListCatalog from "./component/ListCatalog";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import {
  QueryType_Index_1_BannerImage,
  QueryType_Index_2_Team,
  QueryType_Index_3_Op,
  QueryType_Index_4_Action, QueryType_Index_5_3482, QueryType_Index_6_Images, QueryType_Index_7_Videos, QueryType_Menu,QueryType_Years
} from "./js/rotaryDeclare";
import Vue from "vue";
import FileUploadButton from "@/views/taylorAdmin/component/FileUploadButton";
import ContentHome from "@/views/rotary/contentHome";


export default {
  components: {ContentHome, FileUploadButton, ListCatalog},
  //name: "conentCatalog",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{},
      dataYears:[],
      QueryType_Index_1_BannerImage:QueryType_Index_1_BannerImage,
      QueryType_Index_2_Team:QueryType_Index_2_Team,
      QueryType_Index_3_Op:QueryType_Index_3_Op,
      QueryType_Index_4_Action:QueryType_Index_4_Action,
      QueryType_Index_5_3482:QueryType_Index_5_3482,
      QueryType_Index_6_Images:QueryType_Index_6_Images,
      QueryType_Index_7_Videos:QueryType_Index_7_Videos,

      QueryType_Menu:QueryType_Menu,
      QueryType_Years:QueryType_Years,
      YearString:"",
      SelectYear:"nothing", //避免 ContentHome ,載入本年度的資料，所以給nothing,就查不到資料
    };
  },
  methods: {
    loadData() {
      // let loader=util.ShowLoading(this);
      let dt=new Date();
      this.YearString=dt.getFullYear() +"" + "-" + (dt.getFullYear()-1);


      let that=this;
      apiAdmin.api_getContent(this.QueryType_Years).then((data)=>{
        let dataArray=apiAdmin.init(data.data.data);
        that.dataYears=dataArray;
        // util.HideLoading(loader);
      })
    },
    saveDataYear(){
      if (confirm('確定封存?  網站首頁資料封存後，會清空(網站使用者會看到空白的網站) ，需再補下年度資料')){
        let that=this;
        apiAdmin.api_yearArchive().then(()=>{
          alert('執行完成');
          that.loadData();
        })
      }
    },
    loadDataYear(item) {
      this.SelectYear=item.Year;

      let that=this;
      that.datas={};
      apiAdmin.api_getContent(this.QueryType_Menu +"_"+ item.Year).then((data)=>{
        let dataArray=apiAdmin.init(data.data.data);

        if (dataArray.length===0){
          that.datas={
            Menu1:{},
            Menu2:{},
          };
        }else{
          that.datas=dataArray;
          that.datas.YearData=item;//特殊處理，將這個值存在這裡，後續用來放圖片
        }
      })

      this.$refs.contentHome.loadData(this.SelectYear);
    },
    submit(){
      apiAdmin.api_saveContent(this.QueryType_Years,this.dataYears).then((data)=>{
        console.log(data);
        alert('儲存成功')
      })
    },
    gotoMenu(item){
      this.$router.push({
        path: item.url,
      });
    },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    uploadSuccess(image,result){
      if (result && result.data.FileCount>0){
        image.LogoUrl=result.data.FileUrls[0]
      }else{
        alert("檔案上傳失敗")
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
.bbutton{
  background-color: #1b9e3e;
  color: white;
  width: 100%;
  margin-bottom: 10px;
}
.cbutton{
  color: white;
  /*width: 100%;*/
  margin-bottom: 10px;
}
.abutton{
  color: white;
  width: 100%;
  margin-bottom: 10px;
}
</style>
